import {routerFarmIdAtom} from "./routerStore";
import {useAtomValue} from "jotai";
import {useActiveCompanyFields} from "../hooks/activeCompanyFieldsHooks";
import {useMemo} from "react";

export const useActiveFarmFields = () => {
    const fieldsState = useActiveCompanyFields();
    const activeFarmId = useAtomValue(routerFarmIdAtom);
    const fields = useMemo(() => (fieldsState.isSuccess ? fieldsState.data.fields : []), [fieldsState]);

    return fields.filter((field) => field.farmId === activeFarmId);
};
